module.exports = __webpack_public_path__ + "img/dzhjhns1.9960b6e1.png";